import i18next from 'i18next';
export const ValidationConstants = {
    REQUIRED: 'REQUIRED',
};
export const required = (value) => {
    if (value === null || value === undefined || value === '' || value === false) {
        return ValidationConstants.REQUIRED;
    }
    return undefined;
};
export const getErrorLabel = (error, props) => {
    switch (error) {
        case ValidationConstants.REQUIRED:
            if (props === null || props === void 0 ? void 0 : props.requiredString) {
                return props === null || props === void 0 ? void 0 : props.requiredString;
            }
            return i18next.t($ => $.required);
        default:
            return error;
    }
};
